/**
 * DIISEA product info — Product highlights Learn more / Show less
 * Mobile: tap a title to reveal its description. Theme editor safe.
 */
(function () {
  var ATTR_INIT = 'data-diisea-highlights-ready';
  var MOBILE_MQ = '(max-width: 767px)';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function canCollapse(root) {
    return !!(root && root.classList.contains('diisea-product-highlights--collapse-mobile') && isMobile());
  }

  function setItemOpen(item, open) {
    var name = item.querySelector('.diisea-product-highlights__name');
    item.classList.toggle('is-open', open);
    if (!name) return;
    if (open) {
      name.setAttribute('aria-expanded', 'true');
    } else if (name.hasAttribute('aria-expanded')) {
      name.setAttribute('aria-expanded', 'false');
    }
  }

  function syncCollapsibleUi(root) {
    var items = root.querySelectorAll('.diisea-product-highlights__item--collapsible');
    var mobileCollapse = canCollapse(root);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var name = item.querySelector('.diisea-product-highlights__name');
      if (!name) continue;
      if (mobileCollapse) {
        name.setAttribute('role', 'button');
        name.setAttribute('tabindex', '0');
        name.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      } else {
        name.removeAttribute('role');
        name.removeAttribute('tabindex');
        name.removeAttribute('aria-expanded');
        item.classList.remove('is-open');
      }
    }
  }

  function toggleItem(root, item) {
    var willOpen = !item.classList.contains('is-open');
    var openItems = root.querySelectorAll('.diisea-product-highlights__item--collapsible.is-open');
    for (var i = 0; i < openItems.length; i++) {
      setItemOpen(openItems[i], false);
    }
    if (willOpen) setItemOpen(item, true);
  }

  function setExpanded(root, expanded) {
    var toggle = root.querySelector('[data-diisea-highlights-toggle]');
    var extra = root.querySelector('[data-diisea-highlights-extra]');
    var label = root.querySelector('[data-diisea-highlights-label]');
    if (!toggle || !extra) return;

    var more = toggle.getAttribute('data-label-more') || 'Learn more';
    var less = toggle.getAttribute('data-label-less') || 'Show less';

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) label.textContent = expanded ? less : more;
    root.classList.toggle('is-expanded', expanded);

    if (expanded) {
      extra.hidden = false;
      void extra.offsetHeight;
      extra.classList.add('is-open');
    } else {
      extra.classList.remove('is-open');
      var extraItems = extra.querySelectorAll('.diisea-product-highlights__item--collapsible.is-open');
      for (var i = 0; i < extraItems.length; i++) {
        setItemOpen(extraItems[i], false);
      }
      var ms = prefersReducedMotion() ? 0 : 280;
      window.setTimeout(function () {
        if (!root.classList.contains('is-expanded')) {
          extra.hidden = true;
        }
      }, ms);
    }
  }

  function onToggleClick(event) {
    var toggle = event.currentTarget;
    var root = toggle.closest('[data-diisea-product-highlights]');
    if (!root) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    setExpanded(root, !expanded);
  }

  function onRootClick(event) {
    var root = event.currentTarget;
    if (!canCollapse(root)) return;
    if (event.target.closest('[data-diisea-highlights-toggle]')) return;
    var name = event.target.closest('.diisea-product-highlights__name');
    if (!name || !root.contains(name)) return;
    var item = name.closest('.diisea-product-highlights__item--collapsible');
    if (!item) return;
    event.preventDefault();
    toggleItem(root, item);
  }

  function onRootKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var root = event.currentTarget;
    if (!canCollapse(root)) return;
    var name = event.target.closest('.diisea-product-highlights__name');
    if (!name || !root.contains(name)) return;
    var item = name.closest('.diisea-product-highlights__item--collapsible');
    if (!item) return;
    event.preventDefault();
    toggleItem(root, item);
  }

  function initRoot(root) {
    if (!root || root.getAttribute(ATTR_INIT) === 'true') return;
    var toggle = root.querySelector('[data-diisea-highlights-toggle]');
    var extra = root.querySelector('[data-diisea-highlights-extra]');
    if (toggle && extra) {
      toggle.addEventListener('click', onToggleClick);
      setExpanded(root, false);
    }
    root.addEventListener('click', onRootClick);
    root.addEventListener('keydown', onRootKeydown);
    syncCollapsibleUi(root);
    root.setAttribute(ATTR_INIT, 'true');
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-diisea-product-highlights]');
    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  function onSectionLoad(event) {
    var section = event && event.target;
    if (!section) {
      initAll(document);
      return;
    }
    initAll(section);
  }

  function onViewportChange() {
    var roots = document.querySelectorAll('[data-diisea-product-highlights]');
    for (var i = 0; i < roots.length; i++) {
      syncCollapsibleUi(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  if (window.matchMedia) {
    var mq = window.matchMedia(MOBILE_MQ);
    if (mq.addEventListener) {
      mq.addEventListener('change', onViewportChange);
    } else if (mq.addListener) {
      mq.addListener(onViewportChange);
    }
  }
})();
